module.exports = __webpack_public_path__ + "static/media/Logo.a97ff0b5.jpg";